var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14ZM2.342 4.4l6.46 5.653.061.04a.3.3 0 0 0 .335-.04l6.46-5.653H2.342ZM16.6 5.436l-6.48 5.67-.124.099a1.7 1.7 0 0 1-2.115-.099L1.4 5.436V14a.6.6 0 0 0 .503.592L2 14.6h14a.6.6 0 0 0 .592-.503L16.6 14V5.436Z"
})));

export default SvgMail;